import {
  ApartmentOutlined,
  BankOutlined,
  BranchesOutlined,
  CreditCardOutlined,
  DesktopOutlined,
  FileProtectOutlined,
  GiftOutlined,
  HistoryOutlined,
  IdcardOutlined,
  LockOutlined,
  ProductOutlined,
  ProfileOutlined,
  SafetyOutlined,
  ShopOutlined,
  ShoppingOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';
import type { MenuDataItem } from '@ant-design/pro-components';
import { Link } from '@umijs/max';
import React from 'react';

const sidebarRouteIconMap: Record<string, React.ReactNode> = {
  Logo: <img src="/logo.svg" alt="" width={18} height={18} />,
  ApartmentOutlined: <ApartmentOutlined />,
  BankOutlined: <BankOutlined />,
  BranchesOutlined: <BranchesOutlined />,
  CreditCardOutlined: <CreditCardOutlined />,
  DesktopOutlined: <DesktopOutlined />,
  FileProtectOutlined: <FileProtectOutlined />,
  GiftOutlined: <GiftOutlined />,
  HistoryOutlined: <HistoryOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  LockOutlined: <LockOutlined />,
  ProfileOutlined: <ProfileOutlined />,
  ProductOutlined: <ProductOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  ShopOutlined: <ShopOutlined />,
  ShoppingOutlined: <ShoppingOutlined />,
  UserOutlined: <UserOutlined />,
  UsergroupAddOutlined: <UsergroupAddOutlined />,
};

function getSidebarRouteIcon(icon: MenuDataItem['icon']) {
  if (typeof icon === 'string') {
    return sidebarRouteIconMap[icon];
  }
  return React.isValidElement(icon) ? icon : undefined;
}

type SidebarMenuItem = MenuDataItem & {
  isUrl?: boolean;
  target?: string;
};

type SidebarMenuProps = {
  location?: {
    pathname?: string;
  };
};

export function renderSidebarMenuItem(
  item: SidebarMenuItem,
  defaultDom: React.ReactNode,
  menuProps?: SidebarMenuProps,
) {
  const icon = getSidebarRouteIcon(item.icon);
  const menuItemDom = icon ? (
    <div className="app-sidebar-menu-item">
      <span className="app-sidebar-menu-item-icon">{icon}</span>
      <div className="app-sidebar-menu-item-content">{defaultDom}</div>
    </div>
  ) : (
    defaultDom
  );

  if (item.isUrl || item.children || !item.path) {
    return menuItemDom;
  }

  if (menuProps?.location?.pathname === item.path) {
    return menuItemDom;
  }

  return (
    <Link to={item.path.replace('/*', '')} target={item.target}>
      {menuItemDom}
    </Link>
  );
}
